import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';

import { LessonStatus } from '@app/definitions/interfaces';

@Component({
    selector: 'app-prepare-all-list',
    templateUrl: './prepare-all-list.component.html',
    styleUrls: ['./prepare-all-list.component.scss']
})
export class PrepareAllListComponent implements OnInit, OnDestroy {
    lesson_completed = LessonStatus.LESSON_COMPLETED;

    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor() {}

    public ngOnInit(): void {}

    public ngOnDestroy(): void {
        this.destroy$.next(true);
    }
}
